import React from 'react';
import {
  Chart as ChartJS,
  RadialLinearScale,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { PolarArea } from 'react-chartjs-2';
import 'src/assets/css/Kpis.css';

ChartJS.register(RadialLinearScale, ArcElement, Tooltip, Legend);

export const data = {
  labels: ['MA Accuracy', 'ASM Accuracy', 'Consensus Accuracy', 'Statistical Accuracy'],
  datasets: [
    {
      label: '# of Votes',
      data: [45, 42, 68, 74],
      backgroundColor: [
        'rgba(54, 162, 235, 0.5)', // Transparent blue
        'rgba(255, 99, 132, 0.5)', // Transparent red
        'rgba(75, 192, 192, 0.5)', // Transparent green
        'rgba(255, 205, 86, 0.5)', // Transparent yellow
      ],
      borderWidth: 1,
    },
  ],
};

const options = {
  scales: {
    r: {
      suggestedMax: 100, // Set the maximum value on the y-axis to 100
    },
  },
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
      align: 'left',
      labels: {
        boxWidth: 10,
        borderWidth: 0,
        textAlign: 'left',
        color: 'black',
        font: {
          size: 10,
        },
      },
    },
    tooltip: {
      callbacks: {
        label: (context) => {
          const label = context.label || '';
          if (context.formattedValue) {
            return `${label}: ${context.formattedValue}%`;

          }

          return label;
        },
      },
    },

  },
};

export default function App(props) {
  return (
    <>
      <div className='Polar'>
        <div className='row'>
          <div className='col-lg-5'>
            <div className='componentNameC'>{props.prams.prams.component}</div>
          </div>

          <div className='col-lg-5'></div>

          <div className='col-lg-2'>
            <div className="form-check component_legend">
              <span className="bigcheck">
                <label className="bigcheck">
                </label>
              </span>
            </div>
          </div>
        </div>
        <div className="p-2 Polar1">
          <div className="row Polar2">
            <div className='col-lg-12 text-center Polar3'> {/* Use text-center class to center the content */}
              <div className='Polar4'> {/* Use display: inline-block */}
                <PolarArea data={data} options={options} />
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
}
